import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({
	selector: 'app-sliders',
	templateUrl: './sliders.component.html',
	styleUrls: ['./sliders.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class SlidersComponent implements OnInit {

	constructor() { }

	ngOnInit() { }

}



// WEBPACK FOOTER //
// ./src/app/sliders/sliders.component.ts